export default __webpack_public_path__ + "static/media/03.2e026dd9.webp";